/* LONGEVX · Artículos: convierte tramos largos de texto en tarjetas deslizables (solo texto). */
(() => {
  const content = document.querySelector('[data-article-content]');
  if (!content || content.dataset.lxCards) return;
  content.dataset.lxCards = '1';

  const chev = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="${d === 'l' ? 'M14.5 5.5L8 12l6.5 6.5' : 'M9.5 5.5L16 12l-6.5 6.5'}"/></svg>`;
  const isRefs = (el) => el && (el.classList.contains('lx-refs') || el.classList.contains('lx-refs-title'));
  const textLen = (el) => (el.textContent || '').trim().length;

  const build = (cards) => {
    const wrap = document.createElement('div');
    wrap.className = 'lx-tcards';
    const track = document.createElement('div');
    track.className = 'lx-tcards__track';
    cards.forEach((c, i) => {
      const card = document.createElement('div');
      card.className = 'lx-tcard';
      card.innerHTML = `<span class="lx-tcard__n">${String(i + 1).padStart(2, '0')}</span>`;
      if (c.title) { const t = document.createElement('p'); t.className = 'lx-tcard__t'; t.innerHTML = c.title; card.appendChild(t); }
      c.nodes.forEach((n) => card.appendChild(n));
      track.appendChild(card);
    });
    wrap.appendChild(track);
    const nav = document.createElement('div');
    nav.className = 'lx-tcards__nav';
    nav.innerHTML = `<div class="lx-tcards__bar"><span></span></div><div class="lx-tcards__btns"><button type="button" aria-label="Anterior" data-d="-1">${chev('l')}</button><button type="button" aria-label="Siguiente" data-d="1">${chev('r')}</button></div>`;
    wrap.appendChild(nav);
    const bar = nav.querySelector('.lx-tcards__bar span');
    const upd = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = track.clientWidth / track.scrollWidth;
      bar.style.width = `${Math.max(12, ratio * 100)}%`;
      const p = max > 0 ? track.scrollLeft / max : 0;
      bar.style.transform = `translateX(${p * (100 / Math.max(ratio, 0.12) - 100)}%)`;
    };
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    requestAnimationFrame(upd);
    nav.querySelectorAll('[data-d]').forEach((b) => b.addEventListener('click', () => {
      const card = track.querySelector('.lx-tcard');
      track.scrollBy({ left: (card ? card.offsetWidth + 14 : track.clientWidth * 0.8) * Number(b.dataset.d), behavior: 'smooth' });
    }));
    // arrastre con mouse
    let x0 = null; let s0 = 0; let moved = 0;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; x0 = e.clientX; s0 = track.scrollLeft; moved = 0; });
    window.addEventListener('pointermove', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0; moved = Math.abs(dx);
      if (moved > 4) { track.classList.add('is-dragging'); track.scrollLeft = s0 - dx; }
    });
    window.addEventListener('pointerup', () => {
      if (x0 === null) return;
      x0 = null;
      if (track.classList.contains('is-dragging')) {
        track.classList.remove('is-dragging');
        const card = track.querySelector('.lx-tcard');
        if (card) { const w = card.offsetWidth + 14; track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' }); }
      }
    });
    return wrap;
  };

  const kids = () => [...content.children];

  // 1) Subtítulos h3 seguidos (3 o más) dentro de una sección: cada h3 + su texto pasa a una tarjeta.
  let i = 0;
  let list = kids();
  while (i < list.length) {
    if (list[i].tagName === 'H3' && !isRefs(list[i]) && textLen(list[i]) === 0) { i++; continue; }
    if (list[i].tagName === 'H3' && !isRefs(list[i])) {
      const groups = [];
      let j = i;
      while (j < list.length && list[j].tagName === 'H3' && !isRefs(list[j]) && textLen(list[j]) > 0) {
        const g = { title: list[j].innerHTML, nodes: [], head: list[j] };
        let k = j + 1;
        while (k < list.length && !/^H[1-3]$/.test(list[k].tagName) && !isRefs(list[k])) { g.nodes.push(list[k]); k++; }
        groups.push(g);
        j = k;
      }
      const ok = groups.length >= 3 && groups.every((g) => g.nodes.length > 0 && g.nodes.reduce((a, n) => a + textLen(n), 0) < 1800);
      if (ok) {
        const anchor = groups[0].head;
        const wrap = build(groups.map((g) => ({ title: g.title, nodes: g.nodes })));
        anchor.before(wrap);
        groups.forEach((g) => g.head.remove());
        list = kids();
        i = list.indexOf(wrap) + 1;
        continue;
      }
      i = j;
      continue;
    }
    i++;
  }

  // 2) Listas con 3 o más ítems que parten con negrita: cada ítem pasa a una tarjeta.
  content.querySelectorAll(':scope > ul, :scope > ol').forEach((ul) => {
    if (isRefs(ul)) return;
    const items = [...ul.children].filter((li) => li.tagName === 'LI');
    if (items.length < 3) return;
    const led = items.every((li) => li.firstElementChild && li.firstElementChild.tagName === 'STRONG' && li.textContent.trim().indexOf(li.firstElementChild.textContent.trim()) === 0);
    if (items.some((li) => textLen(li) > 620)) return;
    if (!led) {
      if (items.some((li) => textLen(li) < 70)) return;
      ul.replaceWith(build(items.map((li) => { const p = document.createElement('p'); p.innerHTML = li.innerHTML; return { title: '', nodes: [p] }; })));
      return;
    }
    const cards = items.map((li) => {
      const strong = li.firstElementChild;
      const title = strong.innerHTML.replace(/[:.]\s*$/, '');
      strong.remove();
      const p = document.createElement('p');
      p.innerHTML = li.innerHTML.replace(/^\s*[:.—–-]\s*/, '');
      return { title, nodes: [p] };
    });
    ul.replaceWith(build(cards));
  });

  // 3a) Párrafos cortos que funcionan como subtítulo (por ejemplo «NMN + resveratrol»), seguidos de su explicación.
  const isLead = (p) => p.tagName === 'P' && !isRefs(p) && textLen(p) > 0 && textLen(p) <= 80 && !/[.:]$/.test(p.textContent.trim()) || (p.tagName === 'P' && textLen(p) <= 80 && p.firstElementChild && p.firstElementChild.tagName === 'STRONG' && p.textContent.trim() === p.firstElementChild.textContent.trim());
  list = kids();
  i = 0;
  while (i < list.length) {
    if (isLead(list[i])) {
      const groups = [];
      let j = i;
      while (j < list.length && isLead(list[j])) {
        const g = { title: list[j].innerHTML, head: list[j], nodes: [] };
        let k = j + 1;
        while (k < list.length && list[k].tagName === 'P' && !isLead(list[k]) && !isRefs(list[k])) { g.nodes.push(list[k]); k++; }
        if (!g.nodes.length) break;
        groups.push(g);
        j = k;
      }
      if (groups.length >= 3 && groups.every((g) => g.nodes.reduce((a, n) => a + textLen(n), 0) < 1200)) {
        const wrap = build(groups.map((g) => ({ title: g.title.replace(/<\/?strong>/g, ''), nodes: g.nodes })));
        groups[0].head.before(wrap);
        groups.forEach((g) => g.head.remove());
        list = kids();
        i = list.indexOf(wrap) + 1;
        continue;
      }
      i = Math.max(j, i + 1);
      continue;
    }
    i++;
  }

  // 3) Secciones con 4 o más párrafos seguidos: el primero queda como introducción y el resto pasa a tarjetas.
  list = kids();
  i = 0;
  while (i < list.length) {
    if (list[i].tagName === 'P' && !isRefs(list[i])) {
      let j = i;
      while (j < list.length && list[j].tagName === 'P' && !isRefs(list[j]) && !list[j].querySelector('img')) j++;
      const run = list.slice(i, j);
      if (run.length >= 4 && i > 0 && run.slice(1).every((p) => textLen(p) > 20 && textLen(p) < 560)) {
        const rest = run.slice(1);
        const wrap = build(rest.map((p) => ({ title: '', nodes: [p] })));
        run[0].after(wrap);
        list = kids();
        i = list.indexOf(wrap) + 1;
        continue;
      }
      i = Math.max(j, i + 1);
      continue;
    }
    i++;
  }
})();
